import React from 'react';

const visited = ['🇲🇻', '🇱🇰', '🇸🇦'];

const favourites = [
   {
      icon: (
         <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 10c1.5-2 3-2 4.5 0S9.5 12 11 10s3-2 4.5 0 3 2 4.5 0" />
            <path d="M2 15c1.5-2 3-2 4.5 0S9.5 17 11 15s3-2 4.5 0 3 2 4.5 0" />
         </svg>
      ),
      label: 'Ocean',
      color: 'text-sky-500 bg-sky-500/10 ring-sky-500/20',
   },
   {
      icon: (
         <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 20l5-8 4 5 3-4 6 7H3z" />
            <path d="M18 8a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" />
         </svg>
      ),
      label: 'Mountains',
      color: 'text-emerald-500 bg-emerald-500/10 ring-emerald-500/20',
   },
   {
      icon: (
         <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9c4-2 8 2 12 0s6-4 6-4v14H3V9z" />
            <path d="M3 14c4-2 8 2 12 0" />
         </svg>
      ),
      label: 'Countryside',
      color: 'text-lime-600 bg-lime-500/10 ring-lime-500/20',
   },
   {
      icon: (
         <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <path d="M2 20l5-9 5 5 3-5 7 9H2z" />
            <path d="M4 20v-3a2 2 0 0 1 2-2h1" />
            <path d="M15 8h.01" />
         </svg>
      ),
      label: 'Camping',
      color: 'text-amber-500 bg-amber-500/10 ring-amber-500/20',
   },
   {
      icon: (
         <svg viewBox="0 0 24 24" fill="none" className="h-5 w-5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
            <ellipse cx="12" cy="17" rx="8" ry="3" />
            <path d="M12 14c-2.5-2-4-5-4-8a4 4 0 0 1 8 0c0 3-1.5 6-4 8z" />
         </svg>
      ),
      label: 'Island',
      color: 'text-violet-500 bg-violet-500/10 ring-violet-500/20',
   },
];

const HobbySection = () => {
   return (
      <div className="glass-card p-5 sm:p-6 animate-fadeUp mt-4">
         <div className="section-eyebrow">Beyond the screen</div>
         <h2 className="mt-2 font-display text-base sm:text-lg font-bold tracking-tight">
            Travelling & exploring the world.
         </h2>
         <p className="mt-2 text-[13px] leading-relaxed text-zinc-500 dark:text-zinc-400">
            When I step away from the keyboard, I travel. There&apos;s something about being somewhere new
            that resets everything. Been to a few places so far, and this list is only growing.
         </p>

         {/* Visited flags */}
         <div className="mt-4">
            <p className="text-[11px] font-semibold uppercase tracking-widest text-zinc-400 dark:text-zinc-500 mb-2">Places visited</p>
            <div className="flex items-center gap-2 flex-wrap">
               {visited.map((flag) => (
                  <span
                     key={flag}
                     className="text-2xl leading-none rounded-xl bg-zinc-100 dark:bg-zinc-800/60 ring-1 ring-zinc-200 dark:ring-zinc-700/60 px-3 py-2 select-none"
                  >
                     {flag}
                  </span>
               ))}
               <span className="inline-flex items-center gap-1 rounded-full bg-brand-500/10 px-3 py-1.5 text-[11px] font-semibold text-brand-600 dark:text-brand-400 ring-1 ring-brand-500/20">
                  <span className="relative flex h-1.5 w-1.5">
                     <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-brand-400 opacity-75" />
                     <span className="relative inline-flex h-1.5 w-1.5 rounded-full bg-brand-500" />
                  </span>
                  More to come
               </span>
            </div>
         </div>

         {/* Favourites */}
         <div className="mt-4">
            <p className="text-[11px] font-semibold uppercase tracking-widest text-zinc-400 dark:text-zinc-500 mb-2">Favourite places</p>
            <div className="flex items-center gap-2 flex-wrap">
               {favourites.map(({ icon, label, color }) => (
                  <span
                     key={label}
                     className={`inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-[12px] font-semibold ring-1 ${color}`}
                  >
                     {icon}
                     {label}
                  </span>
               ))}
            </div>
         </div>
      </div>
   );
};

export default HobbySection;
